/**
 * CocktailBox — Home FAQ Accordion
 * Toggle one item at a time.
 */

(function () {
  'use strict';

  // Keeps the visual state, aria-expanded and the answer's inert in sync
  function setOpen(item, open) {
    var question = item.querySelector('.cb-faq__question');
    var answer = item.querySelector('.cb-faq__answer');
    item.classList.toggle('is-active', open);
    if (question) question.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (answer) {
      if (open) answer.removeAttribute('inert');
      else answer.setAttribute('inert', '');
    }
  }

  function initFaq(section) {
    var items = section.querySelectorAll('.cb-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var question = item.querySelector('.cb-faq__question');
      if (!question || question._bound) return;
      question._bound = true;

      question.addEventListener('click', function () {
        var isActive = item.classList.contains('is-active');

        // Close all items within this section
        items.forEach(function (other) {
          setOpen(other, false);
        });

        // If it wasn't active, open it
        if (!isActive) {
          setOpen(item, true);
        }
      });
    });
  }

  function boot() {
    var sections = document.querySelectorAll('.cb-faq');
    sections.forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init in Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.cb-faq')) {
      initFaq(e.target.querySelector('.cb-faq'));
    }
  });
})();
